import { putApi } from '../../../utils/api'

export function updateSearchResultsProvidersTableConfig(data) {
  return putApi({
    data,
    endpoint: 'idwell-api/api/v3/table/tables/contractors-search/config/',
  })
}
